import React from 'react';
import { Container, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
        Pagina non trovata
      </Typography>
      <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
        <Button variant="contained" onClick={() => navigate('/')}>
          Vai alla home
        </Button>
        <Button variant="outlined" onClick={() => navigate('/login')}>
          Accedi
        </Button>
      </Stack>
    </Container>
  );
}
